export default __webpack_public_path__ + "static/media/s663-6.72f3393a.png";